import { useCallback, useState, DragEvent } from 'react';

interface UseFileDropOptions {
  onFilesSelected?: (files: FileList) => void;
  disabled?: boolean;
}

export function useFileDrop({ onFilesSelected, disabled = false }: UseFileDropOptions) {
  const [isDragging, setIsDragging] = useState(false);

  const handleDragOver = useCallback(
    (e: DragEvent) => {
      e.preventDefault();
      if (!disabled) {
        setIsDragging(true);
      }
    },
    [disabled]
  );

  const handleDragLeave = useCallback((e: DragEvent) => {
    e.preventDefault();
    setIsDragging(false);
  }, []);

  const handleDrop = useCallback(
    (e: DragEvent) => {
      e.preventDefault();
      setIsDragging(false);

      if (!disabled && e.dataTransfer.files && e.dataTransfer.files.length > 0) {
        onFilesSelected?.(e.dataTransfer.files);
      }
    },
    [disabled, onFilesSelected]
  );

  return {
    isDragging,
    handleDragOver,
    handleDragLeave,
    handleDrop
  };
}
